import { ACTIVITY_DISPLAY_TYPE_ORDER, compareActivitiesForDisplay } from './activityDisplayOrder';

export function buildDojoActivityTypeGroups({ dayTypes = {}, visibleDojoActivities = [] }) {
  const groups = {};
  ACTIVITY_DISPLAY_TYPE_ORDER.forEach(type => {
    // Section existence may come from peers, but items/totals are personal.
    const items = dayTypes[type] || [];
    if (!items.length && !visibleDojoActivities.some(activity => activity.type === type)) return;
    groups[type] = {
      items: [...items].sort((a, b) => compareActivitiesForDisplay(type, a, b)),
      total: items.length,
    };
  });
  return groups;
}
